// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3000';
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || '';

// Application Configuration
export const APP_NAME = 'KashLegal GBP Manager';
export const APP_VERSION = '1.0.0';

// California KashLegal Offices Data - REAL DATA
export const CALIFORNIA_OFFICES = [
  {
    id: 1,
    name: 'KashLegal Los Angeles (Beverly Hills)',
    address: '2839 S. Robertson Blvd. Los Angeles CA 90034',
    coordinates: [-118.3870, 34.0259],
    phone: '(888) 527-4128',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJ3VZFf1a5woARTn7D5P3hR74',
    placeId: 'ChIJ3VZFf1a5woARTn7D5P3hR74',
  },
  {
    id: 2,
    name: 'KashLegal San Diego',
    address: '8775 Aero Dr Suite 138, San Diego, CA 92123',
    coordinates: [-117.1581, 32.8007],
    phone: '(619) 650-5845',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJHxDcbIr_24ARimiEVzYFZk0',
    placeId: 'ChIJHxDcbIr_24ARimiEVzYFZk0',
  },
  {
    id: 3,
    name: 'KashLegal Chula Vista',
    address: '750 Otay Lakes Rd, Chula Vista, CA 91910',
    coordinates: [-117.001, 32.6201],
    phone: '(619) 378-9288',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJ6SSaVDtP2YARVicp3ty6bAA',
    placeId: 'ChIJ6SSaVDtP2YARVicp3ty6bAA',
  },
  {
    id: 4,
    name: 'KashLegal Reseda',
    address: '18355 Sherman Way, Reseda, CA 91335',
    coordinates: [-118.5355, 34.2012],
    phone: '(747) 298-5611',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJY4pof32bwoARA4ZnGLXvsRU',
    placeId: 'ChIJY4pof32bwoARA4ZnGLXvsRU',
  },
  {
    id: 5,
    name: 'KashLegal Murrieta',
    address: '25185 Madison Ave, Murrieta, CA 92562',
    coordinates: [-117.2139, 33.5539],
    phone: '(951) 651-0774',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJ3-A6BXuD3IARws8J7WnZ1sU',
    placeId: 'ChIJ3-A6BXuD3IARws8J7WnZ1sU',
  },
  {
    id: 6,
    name: 'KashLegal Temecula',
    address: '27555 Ynez Rd, Temecula, CA 92591',
    coordinates: [-117.1484, 33.4936],
    phone: '(951) 484-1550',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJT9y0bkZ_24AR8vIc9J38AbM',
    placeId: 'ChIJT9y0bkZ_24AR8vIc9J38AbM',
  },
  {
    id: 7,
    name: 'KashLegal Victorville',
    address: '14393 Park Ave, Victorville, CA 92392',
    coordinates: [-117.2928, 34.5362],
    phone: '(760) 454-1654',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJI7dFYGhlw4ARciq505fh4oI',
    placeId: 'ChIJI7dFYGhlw4ARciq505fh4oI',
  },
  {
    id: 8,
    name: 'KashLegal Hesperia',
    address: '17096 Sequoia St., Hesperia CA 92345',
    coordinates: [-117.3009, 34.4264],
    phone: '(760) 919-4264',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJeSoKAyxnw4ARXjrdRaZh8WY',
    placeId: 'ChIJeSoKAyxnw4ARXjrdRaZh8WY',
  },
  {
    id: 9,
    name: 'KashLegal Bakersfield',
    address: '2020 Eye St, Bakersfield, CA 93301',
    coordinates: [-119.0187, 35.3733],
    phone: '(661) 460-2500',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJQzmClpZp6oARCbAXpg-mQOE',
    placeId: 'ChIJQzmClpZp6oARCbAXpg-mQOE',
  },
  {
    id: 10,
    name: 'KashLegal Palm Desert',
    address: '74333 CA-111, Suite 205, Palm Desert, CA 92260',
    coordinates: [-116.3745, 33.7222],
    phone: '(760) 529-8181',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJ9b9Mhyz_2oAR-nqAZUzK2FQ',
    placeId: 'ChIJ9b9Mhyz_2oAR-nqAZUzK2FQ',
  },
  {
    id: 11,
    name: 'KashLegal Fresno',
    address: '4270 N Blackstone Ave Suite 201, Fresno, CA 93726',
    coordinates: [-119.7871, 36.7378],
    phone: '(559) 431-3600',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJR4Ys4zBnlIARL2fpo91ksak',
    placeId: 'ChIJR4Ys4zBnlIARL2fpo91ksak',
  },
  {
    id: 12,
    name: 'KashLegal Sacramento',
    address: '3626 Fair Oaks Blvd, Sacramento, CA 95864',
    coordinates: [-121.3841, 38.6002],
    phone: '(916) 892-1263',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJDQ0c6FbbmoARdo3r3v6Onow',
    placeId: 'ChIJDQ0c6FbbmoARdo3r3v6Onow',
  },
  {
    id: 13,
    name: 'KashLegal Roseville',
    address: '2999 Douglas Blvd Suite #180H, Roseville, CA 95661',
    coordinates: [-121.288, 38.7521],
    phone: '(916) 252-1165',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJ82pkrGMfm4ARjJScfdtFBDw',
    placeId: 'ChIJ82pkrGMfm4ARjJScfdtFBDw',
  },
  {
    id: 14,
    name: 'KashLegal Oakland',
    address: '1300 Clay St, Oakland, CA 94612',
    coordinates: [-122.2749, 37.8044],
    phone: '(510) 800-8293',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJaZcIwceBj4ARPieJiza0Qqs',
    placeId: 'ChIJaZcIwceBj4ARPieJiza0Qqs',
  },
  {
    id: 15,
    name: 'KashLegal Vacaville',
    address: '201 E Monte Vista Ave, Vacaville, CA 95688',
    coordinates: [-122.0444, 38.2593],
    phone: '(707) 883-1555',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJuWOmjVU9hYARWEbFsD7fUxs',
    placeId: 'ChIJuWOmjVU9hYARWEbFsD7fUxs',
  },
  {
    id: 16,
    name: 'KashLegal Fairfield',
    address: '1545 N Texas St, Fairfield, CA 94533',
    coordinates: [-122.0444, 38.2593],
    phone: '(707) 881-9205',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJBxX_QMYVhYARp6nC0bZv55c',
    placeId: 'ChIJBxX_QMYVhYARp6nC0bZv55c',
  },
  {
    id: 17,
    name: 'KashLegal San Jose',
    address: '111 North Market Street, Suite 300, San Jose, CA 95113',
    coordinates: [-121.8907, 37.3387],
    phone: '(408) 443-2463',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJNzPdHe7Nj4ART4RWyeEkm9E',
    placeId: 'ChIJNzPdHe7Nj4ART4RWyeEkm9E',
  },
  {
    id: 18,
    name: 'KashLegal Cupertino',
    address: '10080 N Wolfe Rd, Cupertino, CA 95014',
    coordinates: [-122.0322, 37.323],
    phone: '(408) 882-1441',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJ8UnUPxS1j4AReYN-zEOQEGY',
    placeId: 'ChIJ8UnUPxS1j4AReYN-zEOQEGY',
  },
  {
    id: 19,
    name: 'KashLegal San Mateo',
    address: '1900 S Norfolk St #388, San Mateo, CA 94403',
    coordinates: [-122.2939, 37.5485],
    phone: '(650) 629-1595',
    manager: 'Office Manager',
    status: 'active',
    businessProfileId: 'ChIJW7Te3F-fj4AR0LvKRnufg30',
    placeId: 'ChIJW7Te3F-fj4AR0LvKRnufg30',
  },
];

// Post Types and Categories
export const POST_TYPES = [
  { value: 'update', label: 'Business Update', icon: 'Business' },
  { value: 'event', label: 'Event', icon: 'Event' },
  { value: 'offer', label: 'Offer/Promotion', icon: 'LocalOffer' },
  { value: 'product', label: 'Product/Service', icon: 'Work' },
  { value: 'news', label: 'News/Announcement', icon: 'Announcement' },
  { value: 'question', label: 'Q&A', icon: 'Help' },
];

export const POST_STATUSES = [
  { value: 'draft', label: 'Draft', color: 'grey' },
  { value: 'scheduled', label: 'Scheduled', color: 'orange' },
  { value: 'published', label: 'Published', color: 'green' },
  { value: 'failed', label: 'Failed', color: 'red' },
];

// Review Sentiments
export const REVIEW_SENTIMENTS = [
  { value: 'positive', label: 'Positive', color: 'success', icon: 'ThumbUp' },
  { value: 'neutral', label: 'Neutral', color: 'warning', icon: 'ThumbsUpDown' },
  { value: 'negative', label: 'Negative', color: 'error', icon: 'ThumbDown' },
];

// Languages for Q&A Generator
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', flag: '🇮🇹' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳' },
];

// File Upload Configuration
export const FILE_UPLOAD = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ACCEPTED_TYPES: [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'image/heif',
  ],
  MAX_FILES: 10,
};

// Analytics Time Ranges
export const TIME_RANGES = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '1y', label: 'Last year' },
  { value: 'custom', label: 'Custom range' },
];

// Chart Colors
export const CHART_COLORS = [
  '#1976d2',
  '#dc004e',
  '#2e7d32',
  '#ed6c02',
  '#9c27b0',
  '#00acc1',
  '#8bc34a',
  '#ff5722',
  '#607d8b',
  '#e91e63',
];

// Navigation Menu Items
export const MENU_ITEMS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: 'Dashboard',
    description: 'Overview of all offices and activities',
  },
  {
    title: 'Create Post',
    path: '/posts/create',
    icon: 'Add',
    description: 'Create new posts for Google Business Profile',
  },
  {
    title: 'Photo Manager',
    path: '/photos',
    icon: 'PhotoLibrary',
    description: 'Upload and manage photos with SEO tagging',
  },
  {
    title: 'Calendar',
    path: '/calendar',
    icon: 'CalendarMonth',
    description: 'View and manage scheduled posts',
  },
  {
    title: 'Reviews',
    path: '/reviews',
    icon: 'Reviews',
    description: 'Monitor and respond to customer reviews',
  },
  {
    title: 'Analytics',
    path: '/analytics',
    icon: 'Analytics',
    description: 'Performance metrics and insights',
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: 'Settings',
    description: 'Configure offices and application settings',
  },
  {
    title: 'Admin Panel',
    path: '/admin',
    icon: 'Security',
    description: 'System administration and API controls',
  },
];

// WebSocket Events
export const SOCKET_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  POST_CREATED: 'post:created',
  POST_UPDATED: 'post:updated',
  POST_PUBLISHED: 'post:published',
  REVIEW_RECEIVED: 'review:received',
  PHOTO_UPLOADED: 'photo:uploaded',
  ANALYTICS_UPDATED: 'analytics:updated',
};